/**
 * Boot path for super-admin GeoSim toolbar in production.
 * /?geo_sim_boot=1 marks eligibility so the FAB stays visible after SPA navigations.
 */

import { GEO_SIM_BOOT_PARAM, GEO_SIM_ELIGIBLE_KEY } from "./constants";

export function isGeoSimBootQuery(search?: string): boolean {
  if (typeof window === "undefined" && search == null) return false;
  const q = new URLSearchParams(
    search ?? (typeof window !== "undefined" ? window.location.search : ""),
  );
  return q.get(GEO_SIM_BOOT_PARAM) === "1";
}

export function markGeoSimEligible(): void {
  if (typeof window === "undefined") return;
  try {
    sessionStorage.setItem(GEO_SIM_ELIGIBLE_KEY, "1");
  } catch {
    /* private mode */
  }
}

export function isGeoSimEligibleMarked(): boolean {
  if (typeof window === "undefined") return false;
  try {
    return sessionStorage.getItem(GEO_SIM_ELIGIBLE_KEY) === "1";
  } catch {
    return false;
  }
}

export function clearGeoSimEligible(): void {
  if (typeof window === "undefined") return;
  try {
    sessionStorage.removeItem(GEO_SIM_ELIGIBLE_KEY);
  } catch {
    /* ignore */
  }
}

/**
 * Call once on app shell mount. Returns true if boot param was present.
 * Strips geo_sim_boot from the URL via replaceState (does not hard-reload).
 */
export function consumeGeoSimBoot(): boolean {
  if (typeof window === "undefined") return false;
  if (!isGeoSimBootQuery()) return false;
  markGeoSimEligible();
  try {
    const url = new URL(window.location.href);
    url.searchParams.delete(GEO_SIM_BOOT_PARAM);
    const qs = url.searchParams.toString();
    window.history.replaceState(
      {},
      "",
      `${url.pathname}${qs ? `?${qs}` : ""}${url.hash}`,
    );
  } catch {
    /* ignore */
  }
  return true;
}
